import React from 'react';
import { useIsOpenedStore, useUnreadCountStore } from '../NotificationCenterStore';
import NotificationsIcon from '@mui/icons-material/Notifications';
import cx from 'classnames';
import { useShallow } from 'zustand/shallow';

const MAX_LIMIT = 9;
const MAX_LIMIT_TEXT = '9+';

const Bell = () => {
  const toggleIsOpened = useIsOpenedStore.getState().toggleIsOpened;
  const unreadCount = useUnreadCountStore(useShallow(state => state.unreadCount));

  const showMaxLimitText = unreadCount > MAX_LIMIT;

  return (
    <div className='bell-wrapper' onClick={toggleIsOpened}>
      <NotificationsIcon data-testid='notification-icon' />
      <span className={cx({ 'max-limit-label': showMaxLimitText })}>
        {showMaxLimitText ? MAX_LIMIT_TEXT : unreadCount}
      </span>
    </div>
  );
};

export default Bell;
